import { render, staticRenderFns } from "./PageFunArenaScore.vue?vue&type=template&id=70ab2761&scoped=true&"
import script from "./PageFunArenaScore.vue?vue&type=script&lang=js&"
export * from "./PageFunArenaScore.vue?vue&type=script&lang=js&"
import style0 from "./PageFunArenaScore.vue?vue&type=style&index=0&id=70ab2761&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab2761",
  null
  
)

export default component.exports